/**
 * The one screen from a launcher or Studio click until the app is on screen. The apps portal's
 * shell draws exactly this (`runtime-shell` `OpeningScreen`, `#initial-loading`), and so does
 * `index.html` before this page loads, so the redirects between Studio and the app read as one
 * wait. Its styles are in `index.html`. English only, like the shell it hands over to.
 */
const DOTS: Array<[number, number]> = [
  [13.925, 3.808], [24.051, 3.808], [3.795, 13.97], [13.925, 13.97], [24.051, 13.97], [34.174, 13.97],
  [3.795, 24.128], [13.925, 24.128], [24.051, 24.128], [34.174, 24.128], [13.925, 34.288], [24.051, 34.288],
];

export const OPENING_APP_TITLE = 'Opening your app…';
export const OPENING_APPS_TITLE = 'Loading your apps…';

export function AppOpeningScreen({ portal = false }: { portal?: boolean }) {
  return (
    <div className="connector-loading-root" aria-live="polite">
      <div className="connector-loading-card">
        <div className="connector-loading-icon">
          <svg className="boot-dot-mark" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            {DOTS.map(([cx, cy]) => <circle key={`${cx}-${cy}`} className="boot-dot" cx={cx} cy={cy} r="3.8" />)}
          </svg>
        </div>
        <div className="connector-loading-copy">
          <p className="connector-loading-title" role="status">{portal ? OPENING_APPS_TITLE : OPENING_APP_TITLE}</p>
        </div>
      </div>
    </div>
  );
}
